<template>
    <div class="doctors-box app">
        <header-child></header-child>
        <div class="main-content">
            <van-tabs @click="getSwitchList">
                <van-tab v-for="(item,index) in switchTab" :title="item.name" :key="index">
                    <van-list
                    v-model="isUpLoading"
                    :finished="upFinished"
                    finished-text="没有更多了"
                    @load="onLoad"
                    >
                        <ul class="main-ul clearfix">
                            <li class="main-li fl" v-for="(item,index) in dataList" :key="index" @click="goDetail(item.doctor_id)">
                                <div class="avatar">
                                    <img :src="item.img" alt="" class="img-responsive">
                                </div>
                                <p class="name fwb fs16 color-blank mb4 tc txt_limit">{{item.name}}</p>
                                <p class="post fs14 color-gray mb4 tc txt_limit">{{item.position}}</p>
                                <p class="depart fs14 color-gray mb4 tc txt_limit">{{item.department}}</p>
                                <div class="detail fs12 color-blank txt_limit3">{{item.description}}</div>
                            </li>
                        </ul>
                    </van-list>
                </van-tab>
            </van-tabs>
        </div>
    </div>
</template>

<script>
import HeaderChild from '@/components/HeaderChild'
import { Cell,List,Tab,Tabs } from 'vant';
export default {
    props: {

    },
    components: {
       HeaderChild,
       [List.name]:List,
       [Cell.name]:Cell,
       [Tab.name]:Tab,
       [Tabs.name]:Tabs
    },
    data() {
        return {
            page: 0,//重新获取的当前的页码
            alltotal:0,//总的数据
            pageSize:10,//每一条的页数是10
            dataList:[],
            switchTab:[
                {name:'医生集团委员',id:1},
                {name:'医生集团成员',id:2}
            ],
            status:0,
            list: [],
            isUpLoading:false,//上拉加载
            upFinished:false,//上拉加载完毕
            offset:100,//滚动条与底部距离小于 offset 时触发load事件
        };
    },
    created() {
        
    },
    methods: {
        onLoad(){
            let self = this;
            setTimeout(() => {
                this.$axios.post(this.api.doctorGroup.list,{
                    class:this.switchTab[this.status].id,
                    page:this.page+1,
                    page_size:this.pageSize
                },res =>{
                    this.dataList=this.dataList.concat(res.data);
                    this.alltotal=Number(res.pageInfo.totalCount);
                    this.isUpLoading = false;
                    this.page++;
                    if (this.dataList.length >= this.alltotal) {
                        this.upFinished = true;
                    }
                });
            }, 500);
           
        },
        goDetail:function(id){
            this.$router.push('/doctorGroupDetail/'+id+'.html');
        },
        getSwitchList(index) {
            this.status=index;
            this.isUpLoading = true;
            this.upFinished = false;
            this.dataList=[];
            this.page=0;
            if(this.isUpLoading){
                this.onLoad();
            }
        },
        
    },
    
};
</script>
<style>
.van-tabs__nav--line{padding-bottom:0;}
.van-tabs__line{background-color:#0D3482;width:160px!important;bottom:0;}
.van-tabs--line .van-tabs__wrap{height:50px;background:#fff;box-shadow:0px 1px 0px 0px rgba(235,235,237,1);}
.van-tab{line-height:50px;}
</style>
<style scoped lang="less">
.main-content{margin-top:8px;}
.main-ul{
    padding:16px;
    .main-li{
        width:164px;
        height:245px;
        padding:16px;
        margin-right:15px;
        background:rgba(255,255,255,1);
        box-shadow:0px 0px 10px 0px rgba(0,0,0,0.1);
        border-radius:6px;
        margin-bottom:16px;
        .avatar{
            width:80px;
            height:80px;
            overflow: hidden;
            border-radius:50%;
            margin:0 auto 8px;
        }
        .name{
            height:22px;
            line-height:22px;
        }
        .post{
            height:20px;
            line-height:20px;
        }
        .depart{
            height:20px;
            line-height:20px;
        }
    }
    .main-li:nth-child(even){
        margin-right:0;
    }
}

</style>



// WEBPACK FOOTER //
// src/view/doctors/index.vue